import { Modal } from "react-bootstrap";
import { personalitiesList } from "./skeletons/PersonalitiesList";
import { useEffect, useState } from "react";
function PersonalityDetails(props) {

    const { isOpen, setShowmodal, per, handleShowPersonality } = props;

    const [onePer, setOnePer] = useState([])

    const handleShow = () => {


        setOnePer(personalitiesList.filter((x) => x.personality.trim()?.toLowerCase() === per.trim()?.toLowerCase()));
    };

    useEffect(() => {

        if (per) {
            handleShow()
        }

    }, [isOpen, per])

    return <>
        <Modal
            show={isOpen}
            onHide={() => handleShowPersonality(false, '')}
            dialogClassName="custom-modal position-relative modal-h-650"
            size="lg"
            centered
        >
            <div
                className="position-absolute btn btn-close"
                style={{ top: "25px", right: "20px", zIndex: "99" }}
                onClick={() => { handleShowPersonality(false, '') }}
            ></div>
            <Modal.Body>
                <div className="row">
                    {onePer.map((personality, index) => (
                        <div key={index} className="col border rounded-3 mx-2">
                            <div className="row">
                                <div className="col-12 bg-peach">
                                    <div className="row justify-content-between align-items-center mt-5">
                                        <div className="col-6">
                                            <img src={personality.img_card} alt="card-image"></img>
                                        </div>
                                        <div className="col-6">
                                            <div className="row flex-column align-items-center">
                                                <div className="col-6 d-flex justify-content-center ">
                                                    <img
                                                        width={50}
                                                        src={personality.img_letter}
                                                        alt="card-image-letter"
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <p
                                                        className="text-center fw-semibold"
                                                        style={{
                                                            fontSize: "var(--font-size-h1)",
                                                            lineHeight: "60px",
                                                        }}
                                                    >
                                                        {personality.personality}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row justify-content-end">
                                        <div className="col-12 my-4 d-flex justify-content-start">
                                            {/* <img
                          className="me-2"
                          width={40}
                          src={personality.img_letter}
                          alt="personality-letter"
                        /> */}

                                            {/* <h2
                          className="my-auto"
                          style={{ fontSize: "var(--font-size-h1)", fontWeight: "600" }}
                        >
                          {personality.personality}
                        </h2> */}
                                        </div>
                                        <div className="col-10 mx-auto">
                                            <p className="text-base">{personality.text}</p>
                                            <hr />
                                        </div>
                                        <div className="col-10 mx-auto mb-5">
                                            <div className="row">
                                                <div className="col-2">
                                                    <p className="text-base">
                                                        <strong>Strengths</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p className="text-base">
                                                        {personality.strengths}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p className="text-base">
                                                        <strong>Uniqueness</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p className="text-base">
                                                        {personality.uniqueness}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p className="text-base text-nowrap">
                                                        <strong>Value to Org.</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p className="text-base">
                                                        {personality.valtoorg}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p className="text-base text-nowrap">
                                                        <strong>Challenges</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p className="text-base">
                                                        {personality.challenges}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p className="text-base">
                                                        <strong>Motivations</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p className="text-base">
                                                        {personality.motivations}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            {/* <Modal.Header closeButton className="custom-close-btn">
        </Modal.Header>
      <Modal.Body>
        <div className="row">

        <div className="col p-3 border rounded-3">
                            <div className="">
                                 <div className="d-flex px-3">
                                    <h4 className="me-2 font-size-h3 fw-bold" style={{lineHeight:"30px"}}>78%</h4>
                                    <p>----------------------</p>
                                </div>
                             <div className="d-flex align-items-center ms-2" style={{cursor:"pointer"}} onClick={handleShowPersonalityCard}>
                                <img className="me-2" width={40} src={mediatorLetter}/>
                                <h2 className="mb-0 font-size-h3 fw-bold">Mediator</h2>
                             </div>
                            </div>
                </div>
        </div>
      </Modal.Body> */}
        </Modal>
    </>
}

export default PersonalityDetails;